import { createStore, combineReducers, applyMiddleware } from "redux";
import ajaxCallsInProgress from "./reducers/ajaxStatusReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import appReducer from "./reducers/appReducer";
import thunk from "redux-thunk";
import jobsReducer from "./reducers/jobsReducer";
import b2bReducer from "./reducers/b2bReducer";
import companyReducer from "./reducers/companyReducer";
import userReducer from "./reducers/userReducer";

const reducer = combineReducers({
  ajaxCallsInProgress,
  app: appReducer,
  jobs: jobsReducer,
  b2b: b2bReducer,
  companyList: companyReducer,
  userList: userReducer,
});

const initialState = {};

const middleware = [thunk];

const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));

export default store;
